// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"558":"42f016cb","595":"c8cce8a7"}[chunkId] + ".css";
};